import { STEP, ACTION } from '../../@types/state'

const solarFlowStates = {
  id: 'solarFlowStates',
  initial: STEP.PLACEMENT_TYPE,
  states: {
    [STEP.PLACEMENT_TYPE]: {
      entry: ['enterOrSkipPlacementType'],
      on: {
        [ACTION.NEXT]: STEP.LOCATION,
      },
    },
    [STEP.LOCATION]: {
      entry: ['enterOrSkipLocation'],
      on: {
        [ACTION.BACK]: STEP.PLACEMENT_TYPE,
        [ACTION.NEXT]: STEP.SOLAR_INTENT,
      },
    },
    [STEP.SOLAR_INTENT]: {
      on: {
        [ACTION.BACK]: STEP.LOCATION,
        [ACTION.NEXT]: STEP.TIME_HORIZON,
      },
    },
    [STEP.TIME_HORIZON]: {
      on: {
        [ACTION.BACK]: STEP.SOLAR_INTENT,
        [ACTION.NEXT]: STEP.PLEASE_WAIT,
      },
    },
    [STEP.PLEASE_WAIT]: {
      on: {
        [ACTION.BACK]: STEP.TIME_HORIZON,
        [ACTION.NEXT]: STEP.CONTACT,
      },
    },
    [STEP.CONTACT]: {
      on: {
        [ACTION.BACK]: STEP.TIME_HORIZON,
        [ACTION.NEXT]: STEP.RESPONSE_SOLAR,
      },
    },
    [STEP.RESPONSE_SOLAR]: {},
  },
}

export default solarFlowStates
